export default __webpack_public_path__ + "static/media/girlReading@2x.d59cd113.png";